// Leave room for multipart fields beneath the server's 16 MiB request limit.
export const MAX_UPLOAD_BYTES = 15 * 1024 * 1024;
export function exceedsUploadLimit(files: readonly Pick<File, "size">[]): boolean {
  return files.reduce((total, file) => total + file.size, 0) > MAX_UPLOAD_BYTES;
}
